import React from "react";
import { Toast } from "react-bootstrap";
import { setComponentFlag, componentFlagValue } from "presentation/utils/functions/generic";

class EvaluationResultLabelTips extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        const { component, form } = this.props;


        return (
            <div className="tips-container">
                <Toast
                    onClose={() => setComponentFlag(component, 'deleteTip', false)}
                    show={componentFlagValue(component, 'deleteTip')}
                    delay={6000}
                    autohide
                    position={"top-end"}
                >
                    <Toast.Header className="toast-header-red">
                        <strong className="me-auto">BasicoApp</strong>
                    </Toast.Header>
                    <Toast.Body>Opa! O rótulo de resultados de avaliação precisa ter ao menos um termo</Toast.Body>
                </Toast>
            </div>
        );
    };
}

export default EvaluationResultLabelTips;


